// @flow

import _ from 'lodash';
import React, { Children, Component, type Node } from 'react';
import CookieBanner from 'client/components/banner/CookieBanner';
import HtmlHead from 'client/components/htmlHead';
import CONTENTFUL_ENTRY_ID from 'client/constants/contentfulEntry';
import { fetchUser } from 'client/actions/user';
import { fetchContentful } from 'client/actions/contentful';
import NpnFooter from 'client/components/npnFooter';
import 'client/styles/common.scss';
import { TAX_META_IMG } from '../constants/urls';

type Props = {
  children?: Node,
};

class App extends Component<Props> {
  static fetchData({ dispatch }: { dispatch: Function }) {
    return Promise.resolve(dispatch(fetchUser())).then((user) => {
      const locale = _.get(user, 'locale', 'es-US');
      return dispatch(fetchContentful(CONTENTFUL_ENTRY_ID.TAX_PAGE, locale));
    });
  }

  static defaultProps = {
    children: null,
  };

  render() {
    return (
      <div>
        <HtmlHead
          title="Stride Tax | Stride Health"
          description="Save thousands on taxes! Download Stride Tax to easily track your expenses and find savings. It's free!"
          imageUrl={TAX_META_IMG} />
        {Children.only(this.props.children)}
        <CookieBanner />
        <NpnFooter showPhone={false} />
      </div>
    );
  }
}

export default App;
